import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    Security,
    LocationOn,
    Home,
    People,
    CheckCircle,
    WarningAmber,
    Lock,
    Female,
    Visibility,
    Info,
    Shield,
    MeetingRoom
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {/* 目次 */}
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    はじめに：女性のルームシェア、その魅力と課題
                                </Link>
                            </ListItem>

                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('security-check')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェア物件のセキュリティチェック項目
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('roommate-cautions')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    女性同士で気をつけたいルームメイト関係
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('crime-prevention')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアのための防犯対策
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('area-selection')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    安心できるエリアの選び方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ・安心してルームシェアを始めるために
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    はじめに：女性のルームシェア、その魅力と課題
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    近年、女性の間でルームシェアの人気が高まっています。経済的なメリットだけでなく、同じ価値観を持つ仲間と楽しい生活を送りたいというニーズが増え、さまざまなライフスタイルに合わせたルームシェア物件が登場しています。
                    しかし、女性ならではの視点で考えなければならない「安全」「安心」の問題も多く存在します。本記事では、女性向けルームシェアで押さえておきたい物件選びのポイントや、防犯・人間関係の注意点について徹底解説します。
                </Typography>
                <Box sx={{ my: 3, display: { xs: 'block', sm: 'flex' }, alignItems: 'center' }}>

                    <Typography variant="body2" color="text.secondary">
                        ルームシェアは生活に彩りを与え、信頼できる仲間と支え合いながら過ごす特別な時間。しかし、女性同士だからこそ気をつけたいポイントもたくさん。この記事で最新の安全情報をしっかりチェックしましょう。
                    </Typography>
                </Box>
            </Box>


            {/* セキュリティチェック */}
            <Box id="security-check" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <Security sx={{ verticalAlign: 'middle', mr: 1, color: '#1565c0' }} />
                    ルームシェア物件のセキュリティチェック項目
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    物件選びで最も重要なのが「安全性」。女性向けルームシェア物件を選ぶ際、必ずチェックしたい項目をまとめました。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><Lock color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="オートロック・ダブルロック"
                            secondary="玄関や部屋の鍵が二重になっているか必ず確認しましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><Visibility color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="防犯カメラ・センサーライト"
                            secondary="共用部やエントランス、駐輪場など死角になりやすい場所の監視体制も重要です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><MeetingRoom color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="個室のプライバシー"
                            secondary="部屋のドアに鍵がついているか、窓やバルコニーの施錠ができるか確認しましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><WarningAmber color="error" /></ListItemIcon>
                        <ListItemText
                            primary="非常時の避難経路・通報ボタン"
                            secondary="万が一の時、スムーズに避難や通報ができるかも大事なポイントです。"
                        />
                    </ListItem>
                </List>
                <Paper elevation={2} sx={{ bgcolor: '#e3f2fd', p: 2, mt: 2, borderRadius: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        物件見学時はここを確認！
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                            <ListItemText primary="エントランスや共用部の防犯設備" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                            <ListItemText primary="ごみ置き場・駐輪場など人目につきにくい場所の安全性" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                            <ListItemText primary="室内や窓の鍵の状態" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                            <ListItemText primary="宅配ボックスやポストのセキュリティ" />
                        </ListItem>
                    </List>
                </Paper>
                <Box sx={{ my: 3 }}>

                </Box>
            </Box>

            {/* 女性同士の注意点 */}
            <Box id="roommate-cautions" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <People sx={{ verticalAlign: 'middle', mr: 1, color: '#ef5350' }} />
                    女性同士で気をつけたいルームメイト関係
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアでは人間関係もとても大切です。特に女性同士の場合、生活習慣やプライバシー意識の違いがストレスにつながることも。長く快適に暮らすために、以下の点に注意しましょう。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><Info color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="お互いのプライバシーを尊重"
                            secondary="個室や私物には立ち入らない、SNSでの写真投稿も配慮を。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><Info color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="共用部の使い方を明確に"
                            secondary="掃除やゴミ出しなど、ルールを事前に決めておくことでトラブルを防げます。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><Info color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="生活リズムのすり合わせ"
                            secondary="帰宅時間やシャワーの順番など、無理のない範囲で調整しましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><Info color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="金銭トラブルを防ぐ"
                            secondary="光熱費や消耗品の精算はアプリや表に残しておくのがおすすめです。"
                        />
                    </ListItem>
                </List>
                <Paper elevation={0} sx={{ bgcolor: '#fffde7', p: 2, mt: 2, borderRadius: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        専門家からのアドバイス
                    </Typography>
                    <Typography variant="body2">
                        「気になることは早めに相談・共有」これは円満な関係の最大のコツ。小さな違和感も、ためこまずに言葉にしましょう。事前にLINEグループやノートアプリでやりとりルールを決めておくのも有効です。
                    </Typography>
                </Paper>
                <Box sx={{ my: 3 }}>

                </Box>
            </Box>

            {/* 防犯対策 */}
            <Box id="crime-prevention" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <Shield sx={{ verticalAlign: 'middle', mr: 1, color: '#8e24aa' }} />
                    ルームシェアのための防犯対策
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    どんなに設備が整っていても、日頃の意識も大切です。女性向けルームシェアで実践できる防犯対策を紹介します。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><Lock color="primary" /></ListItemIcon>
                        <ListItemText primary="在宅時・外出時の施錠徹底" secondary="玄関・窓の鍵は必ず施錠。ちょっとした外出でも注意しましょう。" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><WarningAmber color="error" /></ListItemIcon>
                        <ListItemText primary="知らない人を安易に招かない" secondary="ルームメイトの了承なしに第三者を招かないルールを設けるのがベスト。" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><Visibility color="primary" /></ListItemIcon>
                        <ListItemText primary="不審者・勧誘には即対応" secondary="不審な訪問や勧誘にはインターホン越しで対応し、状況に応じて管理会社や警察に連絡を。" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="防犯グッズの活用" secondary="防犯ブザーやスマートキー、防犯アプリなども積極的に利用しましょう。" />
                    </ListItem>
                </List>
                <Box sx={{ my: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Card sx={{ maxWidth: 345 }}>
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        <Lock color="secondary" sx={{ mr: 1 }} />
                                        個室の施錠・窓のロック
                                    </Typography>
                                    <Typography variant="body2">
                                        個室の鍵や窓の補助錠があると、より安心です。必要に応じて追加のロックも検討しましょう。
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Card sx={{ maxWidth: 345 }}>
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        <Security color="primary" sx={{ mr: 1 }} />
                                        共有で防犯意識を高める
                                    </Typography>
                                    <Typography variant="body2">
                                        ルームメイト同士で「防犯チェックリスト」を作成し、定期的に確認・声をかけ合うこともおすすめです。
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* 安心エリア選び */}
            <Box id="area-selection" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <LocationOn sx={{ verticalAlign: 'middle', mr: 1, color: '#43a047' }} />
                    安心できるエリアの選び方
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    立地や周辺環境も、女性のルームシェア生活を左右する大きな要素です。安心して住めるエリアを選ぶには、次のポイントをチェックしましょう。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
                        <ListItemText primary="夜道や帰宅経路の明るさ" secondary="駅やバス停からの道が明るく、人通りが多いか。防犯灯の数も重要。" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
                        <ListItemText primary="近隣施設の充実度" secondary="コンビニ、スーパー、交番やクリニックが近いと安心度が高まります。" />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
                        <ListItemText primary="治安データのチェック" secondary="自治体の犯罪マップや口コミサイトも活用して、エリアの評判を調べましょう。" />
                    </ListItem>
                </List>
                <Paper elevation={0} sx={{ bgcolor: '#e3f2fd', p: 2, mt: 2, borderRadius: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        エリア選びのちょっとしたコツ
                    </Typography>
                    <Typography variant="body2">
                        物件周辺を昼夜で歩いてみる／最寄り駅の利用者層や時間帯の雰囲気を観察する／女性向けのシェアハウスが多いエリアは、治安や利便性も比較的良い傾向があります。
                    </Typography>
                </Paper>
                <Box sx={{ my: 3 }}>
                    <Box
                        component="img"
                        src="/images/blog/safe-area-night_josei-muke-roomshare-erabikata-anzen-anshin.jpg"
                        alt="夜でも明るい照明が続く住宅街の道。女性が安心して歩けるように防犯灯が点灯し、駅から物件への帰宅経路の安全性を強調している。"
                        sx={{ width: '100%', maxWidth: 500, borderRadius: 2, mx: 'auto', display: 'block' }}
                    />
                </Box>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ・安心してルームシェアを始めるために
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    女性のルームシェアは、経済的なメリットや新たな出会い、心強い仲間との暮らしなど多くの魅力があります。しかし、安心して長く快適に暮らすためには、防犯・セキュリティ・人間関係・エリア選びなど多面的な視点が欠かせません。
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Chip label="安全" color="primary" variant="filled" sx={{ mr: 1 }} />
                    <Chip label="女性専用" color="secondary" variant="filled" sx={{ mr: 1 }} />
                    <Chip label="防犯" color="info" variant="filled" />
                </Box>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    本記事で紹介したポイントを参考に、あなたにぴったりの安心できるルームシェア生活を始めてください。物件選び・入居後の生活で不安があれば、管理会社や専門の相談窓口に早めに相談するのも大切です。
                </Typography>

            </Box>
        </Box>
    );
};

const post = {
    id: 'josei-muke-roomshare-erabikata-anzen-anshin',
    slug: 'josei-muke-roomshare-erabikata-anzen-anshin',
    title: '女性向けルームシェアの選び方：安全・安心に暮らすためのポイント総まとめ',
    excerpt: '女性専用物件の特徴 セキュリティチェック 女性同士の注意点 防犯対策 安心エリア選び',
    coverImage: '/images/blog/cover-roomshare-women_josei-muke-roomshare-erabikata-anzen-anshin.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。快適で安心感のある女性向けルームシェア生活の魅力を表現。',
    publishedAt: '2024-06-12T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '女性向け', '防犯・安全'],
    tags: ['女性専用', 'シェアハウス選び', 'セキュリティ', 'エリア選び', 'ルームメイト関係'],
    author: {
        name: '山本 真理',
        avatar: '/images/avatars/yamamoto-mari.jpg',
        bio: '不動産コンサルタントとして10年以上、女性向けシェアハウスや賃貸物件の選び方・安全アドバイスを発信。女性の安心・快適な暮らしをサポートしています。',
        profilePicture: '/images/avatars/yamamoto-mari.jpg'
    },
    viewCount: 1320,
    contentComponent: PostContent
};

export default post;